import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FacilityExtrastockContractorsApi extends Api {
  constructor() {
    super('facility/extrastock_contractors/');
  }
}

export default FacilityExtrastockContractorsApi;
